import { NgModule } from '@angular/core';
import { NumberWithChangeComponent } from './number-with-change.component';

export {
  NumberWithChangeComponent,
  NumberWithChangeConfig,
  CHANGE_DIRECTION,
  CHANGE_TYPE,
} from './number-with-change.component';

export const MODULE_IMPORTS_AND_EXPORTS = [NumberWithChangeComponent];

@NgModule({
  imports: MODULE_IMPORTS_AND_EXPORTS,
  exports: MODULE_IMPORTS_AND_EXPORTS,
})
export class GalaxyNumberWithChangeModule {}
